import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import hoistStatics from 'hoist-non-react-statics';
import Viewer from '../data/queries/Viewer';

export default Component => {
  const C = ({ data: { viewer: { user } = {} } = {}, ...props }) => {
    // XXX Show loading screen if not pre-rendered.
    // if (user === undefined) {
    //   return null;
    // }
    return <Component {...props} user={user} />;
  };
  C.propTypes = {
    data: PropTypes.shape({
      viewer: PropTypes.shape({
        user: PropTypes.object,
      }),
    }).isRequired,
  };
  C.displayName = `withUser(${Component.displayName || Component.name})`;
  return compose(
    graphql(Viewer, { options: { fetchPolicy: 'cache-first' } }),
  )(hoistStatics(C, Component));
};



// WEBPACK FOOTER //
// ./src/helpers/withUser.js